// extracted by mini-css-extract-plugin
module.exports = {"widget":"Widget_widget__1-x8O","icon":"Widget_icon__2WshE","label":"Widget_label__3nbvW"};